// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-policy-page {
    min-height: 100vh;
    padding: 40px 20px;
    background-color: #f8f9fa;
    font-family: 'Noto Sans KR', sans-serif;
}

.privacy-container {
    max-width: 800px;
    margin: 0 auto;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.privacy-header {
    background-color: #1976d2;
    color: white;
    padding: 30px;
    text-align: center;
}

.privacy-header h1 {
    margin: 0 0 10px 0;
    font-size: 28px;
    font-weight: 600;
}

.privacy-subtitle {
    margin: 0;
    font-size: 16px;
    opacity: 0.9;
}

.privacy-content {
    padding: 40px;
    line-height: 1.8;
    color: #333;
}

.privacy-intro {
    margin-bottom: 40px;
    padding: 20px;
    background-color: #e7f3ff;
    border-left: 4px solid #1976d2;
    border-radius: 4px;
}

.privacy-intro p {
    margin: 0;
    font-size: 16px;
    text-align: justify;
}

.privacy-section {
    margin-bottom: 40px;
    padding-bottom: 30px;
    border-bottom: 1px solid #eee;
}

.privacy-section:last-child {
    border-bottom: none;
    margin-bottom: 0;
}

.privacy-section h2 {
    color: #1976d2;
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 20px 0;
    padding-bottom: 10px;
    border-bottom: 2px solid #1976d2;
}

.privacy-section h3 {
    color: #333;
    font-size: 18px;
    font-weight: 600;
    margin: 25px 0 15px 0;
}

.privacy-section p {
    margin: 15px 0;
    text-align: justify;
}

.privacy-section ul {
    margin: 15px 0;
    padding-left: 25px;
}

.privacy-section li {
    margin: 8px 0;
    list-style-type: disc;
}

.privacy-section strong {
    color: #1976d2;
    font-weight: 600;
}

.contact-info {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 6px;
    border: 1px solid #dee2e6;
    margin: 20px 0;
}

.contact-info ul {
    margin: 0;
    padding-left: 20px;
}

.contact-info li {
    margin: 10px 0;
}

.note {
    font-size: 14px;
    color: #666;
    font-style: italic;
    margin: 15px 0;
    padding: 15px;
    background-color: #fff8e1;
    border-left: 3px solid #ffc107;
    border-radius: 4px;
}

.privacy-footer {
    padding: 20px;
    text-align: center;
    background-color: #f8f9fa;
    border-top: 1px solid #eee;
}

.close-button {
    padding: 12px 30px;
    background-color: #6c757d;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.close-button:hover {
    background-color: #5a6268;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
    .privacy-policy-page {
        padding: 20px 10px;
    }

    .privacy-container {
        margin: 0 10px;
    }

    .privacy-header {
        padding: 20px;
    }

    .privacy-header h1 {
        font-size: 24px;
    }

    .privacy-content {
        padding: 20px;
    }

    .privacy-intro {
        padding: 15px;
        margin-bottom: 30px;
    }

    .privacy-section h2 {
        font-size: 18px;
    }

    .privacy-section h3 {
        font-size: 16px;
    }

    .privacy-section {
        margin-bottom: 30px;
        padding-bottom: 20px;
    }

    .contact-info {
        padding: 15px;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,YAAY;AACZ;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".privacy-policy-page {\n    min-height: 100vh;\n    padding: 40px 20px;\n    background-color: #f8f9fa;\n    font-family: 'Noto Sans KR', sans-serif;\n}\n\n.privacy-container {\n    max-width: 800px;\n    margin: 0 auto;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n}\n\n.privacy-header {\n    background-color: #1976d2;\n    color: white;\n    padding: 30px;\n    text-align: center;\n}\n\n.privacy-header h1 {\n    margin: 0 0 10px 0;\n    font-size: 28px;\n    font-weight: 600;\n}\n\n.privacy-subtitle {\n    margin: 0;\n    font-size: 16px;\n    opacity: 0.9;\n}\n\n.privacy-content {\n    padding: 40px;\n    line-height: 1.8;\n    color: #333;\n}\n\n.privacy-intro {\n    margin-bottom: 40px;\n    padding: 20px;\n    background-color: #e7f3ff;\n    border-left: 4px solid #1976d2;\n    border-radius: 4px;\n}\n\n.privacy-intro p {\n    margin: 0;\n    font-size: 16px;\n    text-align: justify;\n}\n\n.privacy-section {\n    margin-bottom: 40px;\n    padding-bottom: 30px;\n    border-bottom: 1px solid #eee;\n}\n\n.privacy-section:last-child {\n    border-bottom: none;\n    margin-bottom: 0;\n}\n\n.privacy-section h2 {\n    color: #1976d2;\n    font-size: 20px;\n    font-weight: 600;\n    margin: 0 0 20px 0;\n    padding-bottom: 10px;\n    border-bottom: 2px solid #1976d2;\n}\n\n.privacy-section h3 {\n    color: #333;\n    font-size: 18px;\n    font-weight: 600;\n    margin: 25px 0 15px 0;\n}\n\n.privacy-section p {\n    margin: 15px 0;\n    text-align: justify;\n}\n\n.privacy-section ul {\n    margin: 15px 0;\n    padding-left: 25px;\n}\n\n.privacy-section li {\n    margin: 8px 0;\n    list-style-type: disc;\n}\n\n.privacy-section strong {\n    color: #1976d2;\n    font-weight: 600;\n}\n\n.contact-info {\n    background-color: #f8f9fa;\n    padding: 20px;\n    border-radius: 6px;\n    border: 1px solid #dee2e6;\n    margin: 20px 0;\n}\n\n.contact-info ul {\n    margin: 0;\n    padding-left: 20px;\n}\n\n.contact-info li {\n    margin: 10px 0;\n}\n\n.note {\n    font-size: 14px;\n    color: #666;\n    font-style: italic;\n    margin: 15px 0;\n    padding: 15px;\n    background-color: #fff8e1;\n    border-left: 3px solid #ffc107;\n    border-radius: 4px;\n}\n\n.privacy-footer {\n    padding: 20px;\n    text-align: center;\n    background-color: #f8f9fa;\n    border-top: 1px solid #eee;\n}\n\n.close-button {\n    padding: 12px 30px;\n    background-color: #6c757d;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.close-button:hover {\n    background-color: #5a6268;\n}\n\n/* 반응형 디자인 */\n@media (max-width: 768px) {\n    .privacy-policy-page {\n        padding: 20px 10px;\n    }\n\n    .privacy-container {\n        margin: 0 10px;\n    }\n\n    .privacy-header {\n        padding: 20px;\n    }\n\n    .privacy-header h1 {\n        font-size: 24px;\n    }\n\n    .privacy-content {\n        padding: 20px;\n    }\n\n    .privacy-intro {\n        padding: 15px;\n        margin-bottom: 30px;\n    }\n\n    .privacy-section h2 {\n        font-size: 18px;\n    }\n\n    .privacy-section h3 {\n        font-size: 16px;\n    }\n\n    .privacy-section {\n        margin-bottom: 30px;\n        padding-bottom: 20px;\n    }\n\n    .contact-info {\n        padding: 15px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
